import Modal from 'component/hoc/modal/Modal';
import React, { useState } from 'react';
import styles from './NewWorkflow.module.scss';
import Input from 'component/atom/forms/input/input/Input';
import Button from 'component/atom/forms/button/Button';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { usePost } from 'hooks/usePost';
import { workflow } from 'hooks/endpoints';

const PriorityModal = ({ isOpen, item, onClose, setRefetch }) => {
  const [isRemove, setIsRemove] = useState(false);
  const { mutate: updatePriority, isPending } = usePost({
    onSuccessToast: 'Priority is updated successfully',
    toastType: 'update',
  });
  const initialValues = {
    priorityLevel: item?.priority || '',
  };

  const validationSchema = Yup.object({
    priorityLevel: Yup.string()
      .required('Priority is required')
      .matches(/^[1-9][0-9]*$/, 'Priority must be a number'),
  });

  const handlePostPriority = (values) => {
    updatePriority(
      {
        url: workflow?.setPriority(item?.id, values.priorityLevel, item?.botId),
        method: 'Put',
      },
      {
        onSuccess: () => {
          onClose();
          setRefetch((prev) => !prev);
          setIsRemove(false);
        },
        onError: () => {
          onClose();
          setRefetch((prev) => !prev);
        },
      }
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Set Priority">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handlePostPriority(values)}
        enableReinitialize
      >
        {({ values, handleChange, errors, touched, handleSubmit }) => (
          <Form className={styles['priority-modal']}>
            <Input
              label="Priority Level"
              name="priorityLevel"
              value={values.priorityLevel}
              onChange={handleChange}
              placeholder="1, 2, 3"
              error={touched.priorityLevel && errors.priorityLevel}
              touched={touched.priorityLevel && errors.priorityLevel}
            />

            <div className={styles.actions}>
              <Button
                onClick={onClose}
                variant="#E4E4E4"
                type="button"
                label="Cancel"
              />
              <Button
                label="Remove"
                variant="#C81111"
                onClick={() => (setIsRemove(true), handlePostPriority(0))}
                isLoading={isRemove ? isPending : null}
              />
              <Button
                label="Save"
                onClick={handleSubmit}
                isLoading={!isRemove ? isPending : null}
              />
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default PriorityModal;
